import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getCivilJobLists } from '../../../api/civil-job-lists';

export const getCivilJobListsAsync = createAsyncThunk(
  'civilJobLists/getCivilJobLists',
  getCivilJobLists
);

export interface CivilJobList {
  id: number;
  name: string;
  defaultQuantity: number | null;
}

interface CivilJobListState {
  data: CivilJobList[];
}

const initialState: CivilJobListState = {
  data: []
};

export default createSlice({
  name: 'civilJobLists',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCivilJobListsAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
  }
});
